module.exports = __webpack_public_path__ + "font/0bae535590ffdc6ffb2cfa45b8fb2ae3.ttf";